import axios from 'axios';

// Interceptor global: si cualquier petición responde 401 (token vencido o inválido),
// limpiamos la sesión y mandamos al usuario de vuelta al login con un mensaje claro.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('nombre');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login?expirado=1';
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
